import React from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css';
import moment from 'moment'
import 'moment/locale/es'
import scriptLoader from 'react-async-script-loader'

import { PersonTypeView, UserRegisterView, ContractView, ResumeView } from '../../views'
import { ValidateInputPure, DirectionPure, SimpleLoading, MessagePure, CompanyInfoPure } from '../../pures'
import { Auth0Service, LocalStorageService, UserService, AddressService, PlanService, ClientService, ContractService, MessageService } from '../../../services'
import { DOMUtil } from '../../../utils'
import { RegistrationValidator } from '../../../validators'
import { useTranslation } from "react-i18next"
import imageFisica from '../../../assets/logos/Persona_fisica.png'
import imageMoral from '../../../assets/logos/Persona_moral.png'
import govoLogo from './../../../assets/logos/logo_govo.legal.jpg'
import { PersonalInformation, PhoneValidation, TermsCondition, Resume, PersonalInformationBlack, PhoneValidationBlack, TermsConditionBlack, ResumeBlack, OTPValidation, PersonalDataInfo, CompanyDataInfo, SummaryInfo, OTPValidationBlack, PersonalDataInfoBlack, CompanyDataInfoBlack, SummaryInfoBlack } from '../../../assets/logos/icons'
import { AVISO_PRIVACIDAD } from './../../../utils/constants'
import { Image } from 'p5';


/**
 * @class RegistrationAction
 * @extends {React.Component}
 * @status no delete
 * @description class defining the functionality of the registration process for the client
 */
class RegistrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  input = React.createRef();

  state = {


    a3Direct: false,
    assignedPackage: [],
    assignedPlans: [],
    avaliablePlans: [],
    businessDataFill: false,
    card: false,
    cellphoneNumber: "",
    changedTranslates: false,
    colony: "",
    contract: {},
    contractBullets: [],
    contractCreated: false,
    contractCreatedError: false,
    creactedContract: [],
    dateResume: "",
    email: "",
    eventId: 0,
    expirationDate: "",
    firstLastName: "",
    firstName: "",
    firstTry: false,
    focused: false,
    isLastStep: false,
    iva: 0,
    loading: false,
    message: "Ocurrio un error",
    messageTransfer: false,
    modalTermsCond: false,
    oneTimePassword: "",
    organization: "",
    paymentType: [],
    personlDataFill: false,
    phoneNumber: "",
    plan: [],
    planChecked: false,
    planStandard: "",
    preload: false,
    priceContract: "",
    priceContractA3Card: "",
    promotion: false,
    rfc: "",
    secondLastName: "",
    selectedPersonType: false,
    selectedPersonTypeId: 1,
    selectedPersonTypeName: "Individual",
    selectedStep: 0, ///cambiar a 0
    showErrorRequesting: false,
    showNotification: false,
    state: "",
    street: "",
    subtotal: 0,
    termnsAndConditions: false,
    total: 0,
    township: "",
    transfer: false,
    transferMessage: false,
    urlPdfTermsCond: AVISO_PRIVACIDAD,
    validationCode: "",
    validationCodeCorrect: false,
    visibleDialogTermsCond: false,
    warning: false,
    zipCode: "",

    physicalSteps: [
      {
        icon: OTPValidation,
        iconBlack: OTPValidationBlack,
        currentStep: 0,
        itemElement: this.props.t("registration.action.otp"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.address",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
      },
      {
        icon: PersonalDataInfo,
        iconBlack: PersonalDataInfoBlack,
        currentStep: 1,
        itemElement: this.props.t("registration.action.personalData"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.personalData",
        labelreturn: this.props.t("registration.action.Steps.exit"),
      },
      {
        icon: CompanyDataInfo,
        iconBlack: CompanyDataInfoBlack,
        currentStep: 2,
        itemElement: this.props.t("registration.action.companyInformation"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: this.props.t("re gistration.action.companyInformation"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
      },
      {
        icon: SummaryInfo,
        iconBlack: SummaryInfoBlack,
        currentStep: 3,
        itemElement: this.props.t("registration.action.resume"),
        itemSup: this.props.t("registration.action.Steps.gotoapp"),
        key: this.props.t("registration.action.resume"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
      },
    ],
    moralSteps: [
      {
        icon: imageMoral,
        itemElement: this.props.t("registration.action.corp"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.personalData",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        itemMoral: this.props.t("registration.action.principalAddress"),
        label: this.props.t("registration.action.corp"),
      },
      {
        icon: PersonalInformation,
        itemElement: this.props.t("registration.action.cotactData"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.address",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        itemMoral: this.props.t("registration.action.physicalData"),
        label: "Datos de contacto",
      },
      {
        icon: PersonalInformation,
        itemElement: this.props.t("registration.action.physicalData"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: "register.fiscalData",
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        itemMoral: this.props.t("registration.action.plansAndPricing"),
        label: this.props.t("registration.action.physicalData"),
      },
      {
        //need to update to the new company registration form information
        icon: TermsCondition,
        itemElement: this.props.t("registration.action.tos"),
        itemSup: this.props.t("registration.action.Steps.nextLaber"),
        key: this.props.t("registration.action.tos"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        itemMoral: this.props.t("registration.action.tos"),
        label: this.props.t("registration.action.tos"),
      },
      {
        icon: Resume,
        itemElement: this.props.t("registration.action.resume"),
        itemSup: this.props.t("registration.action.Steps.gotoapp"),
        key: this.props.t("registration.action.resume"),
        labelreturn: this.props.t("registration.action.Steps.backLaber"),
        label: this.props.t("registration.action.resume"),
      },
    ],
  };

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      top: 760,
      right: 20,
      position: "absolute",
    },
  };

  token = {};
  user = {};
  url = process.env.REACT_APP_ETICKET_API;
  userService = new UserService(this.url);
  addressService = new AddressService(this.url);
  clientService = new ClientService(this.url);
  planService = new PlanService(this.url);
  contractService = new ContractService(this.url);
  localStorageService = new LocalStorageService();
  auth0Service = new Auth0Service();
  domUtil = new DOMUtil();
  validator = RegistrationValidator(this.props.t);
  messageService = new MessageService(this.url);

  fisica = {
    name: this.props.t("registration.action.individual"),
    description: this.props.t("registration.action.physicalDescription"),
    information: this.props.t("registration.action.physicalInformation"),
    image: imageFisica,
  };

  moral = {
    name: this.props.t("registration.action.corp"),
    description: this.props.t("registration.action.moralDescription"),
    information: this.props.t("registration.action.moralInformation"),
    image: imageMoral,
  };

  physicalStepMetadata = [
    { number: 0, component: MessagePure, name: "validateOTP" },
    {
      number: 1,
      component: DirectionPure,
      service: this.addressService,
      method: "createAddress",
      name: "addressForm"
    },

    { number: 2, component: CompanyInfoPure, action: "companyInfoRegister", name: "companyInfoForm" },
    { number: 3, component: ResumeView, name: "summaryView" },
  ];

  moralStepMetadata = [
    { number: 0 },
    {
      number: 1,
      component: DirectionPure,
      service: this.addressService,
      method: "createAddress",
    },
    { number: 2, component: ContractView, action: "validateContract" },
    { number: 3, component: ResumeView },
  ];

  formatter = new Intl.NumberFormat(
    "en-MX",
    { style: "currency", currency: "MXN", currencyDisplay: "narrowSymbol" },
    {
      style: "currency",
      currency: "MXN",
    }
  );


  /**
   * @description creates state component dynamically with name {event.target.name} and sets it to corresponding value.
   * @status no delete
   * @param {*} event
   * @memberof RegistrationAction
   */
  onChangeValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  /**
   * @author Leonel Contreras
   * @description Change the state to select terms and conditions
   * @status no delete
   */
  onAcceptTermnsAndConditions = () =>
    this.setState({ termnsAndConditions: !this.state.termnsAndConditions });

  /**
   * @author Leonel Contreras
   * @description Change the state to select plan
   */
  onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked });

  /**
   * @author Lucia Alvarado
   * @description Change the state to select message of transfer
   * @status no delete
   */
  onAcceptMessageTransfer = () =>
    this.setState({ messageTransfer: !this.state.messageTransfer });

  /**
   * @author Lucia Alvarado
   * @description Accept read message of transfer
   * @status no delete
   */
  onAcceptTransferMessage = () =>
    this.setState({ transferMessage: !this.state.transferMessage });

  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   * @status no delete
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });


  /**
   * @status no delete
   * @param {*} value
   * @memberof RegistrationAction
   */
  openModalTermsCond = (value) => {
    this.setState({
      modalTermsCond: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @status no delete
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
          });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the WARNING dialog modal
   * @status no delete
   * @memberof SignatureRequestAction
   */
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
          });
        }, 4000);
      }
    );
  };


  /**
   * @description hides the error.
   * @status no delete
   * @memberof RegistrationAction
   */
  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Leonel Contreras
   * @description change the personTypeId
   * @status no delete
   * @param {Number} personTypeId
   */
  onSelectPersonType = (personTypeId, personTypeName) => {
    return this.setState({
      selectedPersonType: true,
      selectedPersonTypeName: personTypeName,
      selectedPersonTypeId: personTypeId,
    });
  };

  /**
   * @author Leonel Contreras
   * @description determine the step number
   * @status no delete
   * @param {Number} step
   */
  changeStepNumber = (step, personTypeId) => {
    let stepLenght =
      personTypeId === 1
        ? this.state.physicalSteps.length - 1
        : this.state.moralSteps.length - 1;
    step = step >= stepLenght ? stepLenght : step + 1;
    return step;
  };

  /**
   * @author Leonel Contreras
   * @description Check if is necesary update the translates
   * @status no delete
   * @param {Object[]} steps
   * @param {Function} t
   */
  changeTranslates = (steps, t, i18n) => {
    if (!this.state.changedTranslates && i18n.language !== "es-MX") {
      let translates = this.getTranslates(steps, t);

      for (let i = 0; i < steps.length; i++) {
        const step = steps[i];

        for (let j = 0; j < translates.length; j++) {
          const translate = translates[j];

          if (step.key === translate.key) {
            step.label = translate.value;
          }
        }
      }

      return this.setState({ steps, changedTranslates: true });
    }
  };

  /**
   * @author Leonel Contreras
   * @description Get the required translates
   * @status no delete
   * @param {Object[]} steps
   * @param {Function} t
   */
  getTranslates = (steps, t) => {
    let translates = [];

    steps.forEach((step) => {
      let translate = t(step.key);
      translates.push({ key: step.key, value: translate });
    });

    return translates;
  };

  /**
   * @author Leonel Contreras
   * @description subtract one to step or returned to select person type
   * if step is zero
   * @status no delete
   * @param {number} step
   */
  /////Modificar este
  stepBack = (step) => {
    // if (step === 0) {
    //   this.setState({ selectedPersonType: true });
    //   this.onCloseSesion();
    // } else if (step === 2) {
    //   step = step - 2;
    // } else if (this.state.promotion && step === 3) {
    //   step = step - 2;
    // } else {
    //   step = step - 1;
    // }

    return step - 1;
  };

  /**
   * @author Leonel Contreras
   * @description Change the state when click return button in stepper
   * @status no delete
   * @param {Event} event
   */
  onBackStep = async (event) => {
    event.preventDefault();
    let stepNumber = this.stepBack(this.state.selectedStep);
    this.setState({ selectedStep: stepNumber });
  };


  /**
   * @author Leonel Contreras
   * @description Check if the contract is selected
   * @status no delete
   */
  validateContract = async () => {
    if (!this.state.termnsAndConditions) {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.pleaseTos")
      );
      return false;
    } else if (!this.state.planChecked) {
      await this.toggleWarningRequesting(
        true,
        this.props.t("registration.action.pleaseConfirm")
      );
      return false;
    } else {
      return true;
    }
  };

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   * @status no delete
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };


  /**
   * @description gets the client Image from the database.
   * @status no delete
   * @return {Image} 
   * @memberof RegistrationAction
   */
  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  /**
   * @author Lucia Alvarao
   * @description Handle the submit event
   * @status no delete
   * @param {Object} dataItem
   */
  onSubmit = async (dataItem) => {
    let { selectedPersonTypeId, selectedStep } = this.state;
    let stepNumber = this.changeStepNumber(selectedStep, selectedPersonTypeId);
    let isIndividual = selectedPersonTypeId === 1;
    let isCorporative = selectedPersonTypeId === 2;
    let action =
      this[isIndividual ? "physicalStepMetadata" : "moralStepMetadata"][
        selectedStep
      ].action;
    let result = true;
    let newDataItem = {};
    if (this.state.contractCreated) {
      return this.setState({ selectedStep: stepNumber, isLastStep: true });
    }

    if (action) {
      // Only when the submit step requires an action the result is evaluated
      result = await this[action](dataItem);
      this.handleMessage();
      if (!result) return false;
    }

    if (result) {
      // When result its ok, we can flow to next steps
      if (
        (isIndividual && selectedStep === 1) ||
        (isCorporative && selectedStep === 1)
      ) {
        let userCapturedInformation = {
          firstName: dataItem.firstName || this.state.firstName,
          firstLastName: dataItem.firstLastName || this.state.firstLastName,
          secondLastName: dataItem.secondLastName || this.state.secondLastName,
          rfc: dataItem.rfc || this.state.rfc,
          phoneNumber: dataItem.phoneNumber || this.state.phoneNumber,
          cellphoneNumber:
            dataItem.cellphoneNumber || this.state.cellphoneNumber,
          colony: dataItem.colony || this.state.colony,
          state: dataItem.state || this.state.state,
          street: dataItem.street || this.state.street,
          township: dataItem.township || this.state.township,
          zipCode: dataItem.zipCode || this.state.zipCode,
          personlDataFill: true,
        };

        await this.localStorageService.setLocalStorageItem(
          "userCapturedInformation",
          userCapturedInformation
        );
        this.setState(userCapturedInformation);
        const authId = this.user.userToken ? this.user.userToken.sub : '123'
        let userMetaData = await this.userService.getUser(authId, this.token.idToken)
        let userEmail = userMetaData.userA3Cloud.email
        this.setState({ email: userEmail })
        let messageEmail = await this.messageService.sendEmailMessage(userEmail, this.token.idToken)
        if (!messageEmail) {
          await this.toggleWarningRequesting(
            true,
            "This email is being used by another account."
          );
          return false;
        }
      }

      if (
        (isIndividual && selectedStep === 0) ||
        (isCorporative && selectedStep === 0)
      ) {
        let validationCode = this.state.validationCode;
        const authId = this.user.userToken ? this.user.userToken.sub : '123'
        let userMetaData = await this.userService.getUser(authId, this.token.idToken)
        let userEmail = userMetaData.userAuth0.name
        let codeValidator = await this.messageService.validateEmailMessage(
          userEmail,
          validationCode,
          this.token
        );

        if (codeValidator.data === "Validated") {
          this.setState({
            validationCodeCorrect: true,
          });
        } else {
          await this.toggleWarningRequesting(
            true,
            "Incorrect Code. Please try again."
          );
          return false;
        }

        if (this.state.promotion) {
          return this.setState({ selectedStep: stepNumber + 1 });
        }
      }

      if (isIndividual && selectedStep === 3) {
        if (this.state.promotion) {
          stepNumber = 3;
          this.setState(
            {
              loading: true,
              firstTry: true,
              card: false,
              a3Direct: true,
            },
            async () => {
              newDataItem.firstName = this.state.firstName;
              newDataItem.firstLastName = this.state.firstLastName;
              newDataItem.secondLastName = this.state.secondLastName;
              newDataItem.rfc = this.state.rfc;
              newDataItem.phoneNumber = this.state.phoneNumber;
              newDataItem.cellphoneNumber = this.state.cellphoneNumber;
              newDataItem.colony = this.state.colony;
              newDataItem.state = this.state.state;
              newDataItem.street = this.state.street;
              newDataItem.township = this.state.township;
              newDataItem.zipCode = this.state.zipCode;
              newDataItem.personTypeId = selectedPersonTypeId;
              newDataItem.planLevelId = [
                Number(process.env.REACT_APP_PLAN_PROMOTION),
              ];
              newDataItem.clientName = this.state.clientName;
              newDataItem.rfcTaxData = this.state.rfcTaxData;
              newDataItem.streetTaxData = this.state.streetTaxData;
              newDataItem.colonyTaxData = this.state.colonyTaxData;
              newDataItem.townshipTaxData = this.state.townshipTaxData;
              newDataItem.stateTaxData = this.state.stateTaxData;
              newDataItem.zipCodeTaxData = this.state.zipCodeTaxData;
              newDataItem.accountId = selectedPersonTypeId;
              newDataItem.termnsAndConditions = this.state.termnsAndConditions;
              newDataItem.eventId = this.state.eventId;
              newDataItem.userId = this.state.userId;
              newDataItem.organization = `${newDataItem.firstName} ${newDataItem.firstLastName} ${newDataItem.secondLastName}`;
              let promotionContract = await this.createContract(
                newDataItem,
                this.token
              );
              if (promotionContract.data) {
                this.setState({
                  selectedStep: stepNumber + 2,
                  isLastStep: true,
                });
              } else {
                await this.toggleWarningRequesting(
                  true,
                  "El contrato no pudo ser creado, Favor de intentarlo mas tarde."
                );
                return false;
              }
            }
          );
        }
      }
    }

    if (
      (isIndividual && selectedStep === 3) ||
      (isCorporative && selectedStep === 4)
    ) {
      this.setState(
        {
          loading: true,
          firstTry: true,
        },
        async () => {
          if (this.state.assignedPlans[0]) {
            newDataItem.key = this.state.assignedPlans[0].key;
          }
          newDataItem.firstName = this.state.firstName;
          newDataItem.firstLastName = this.state.firstLastName;
          newDataItem.secondLastName = this.state.secondLastName;
          newDataItem.rfc = this.state.rfc;
          newDataItem.phoneNumber = this.state.phoneNumber;
          newDataItem.cellphoneNumber = this.state.cellphoneNumber;
          newDataItem.colony = this.state.colony;
          newDataItem.state = this.state.state;
          newDataItem.street = this.state.street;
          newDataItem.township = this.state.township;
          newDataItem.zipCode = this.state.zipCode;
          newDataItem.personTypeId = selectedPersonTypeId;
          newDataItem.clientName = this.state.clientName;
          newDataItem.rfcTaxData = this.state.rfcTaxData;
          newDataItem.streetTaxData = this.state.streetTaxData;
          newDataItem.colonyTaxData = this.state.colonyTaxData;
          newDataItem.townshipTaxData = this.state.townshipTaxData;
          newDataItem.stateTaxData = this.state.stateTaxData;
          newDataItem.zipCodeTaxData = this.state.zipCodeTaxData;
          newDataItem.accountId = selectedPersonTypeId;
          newDataItem.termnsAndConditions = this.state.termnsAndConditions;
          newDataItem.eventId = this.state.eventId;
          newDataItem.userId = this.state.userId;

          if (isIndividual) {
            newDataItem.organization = `${newDataItem.firstName} ${newDataItem.firstLastName} ${newDataItem.secondLastName}`;
          } else {
            newDataItem.organization = newDataItem.clientName;
            newDataItem.rfc = newDataItem.rfcTaxData;
          }
          await this.createContract(newDataItem, this.token);
        }
      );
    } else {
      return this.setState({ selectedStep: stepNumber });
    }
  };


  /**
   * @description shows the error
   * @status no delete
   * @param {*} error
   * @memberof RegistrationAction
   */
  showError = (error) => {
    console.error("error", error);
    this.setState({
      contract: {},
      loading: false,
      contractCreatedError: true,
      expirationDate: "",
    });

    setTimeout(() => {
      this.setState({ contractCreatedError: false });
    }, 5000);
  };

  /**
   * @description function to create a contract for the user.
   * @status no delete
   * @param {*} data
   * @param {*} token
   * @memberof RegistrationAction
   */
  createContract = async (data, token) => {
    let contract = await this.contractService.createContract(data, token);
    try {
      if (contract.statusCode === 200) {
        if (this.state.transfer === true) {
          this.setState({
            creactedContract: contract.data,
            priceContract: this.formatter.format(
              contract.data.bankcharge.amount
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.id,
          });
        } else if (this.state.card) {
          this.setState({
            creactedContract: contract.data,
            priceContract: this.formatter.format(
              contract.data.contracts[0].pricing
            ),
            loading: false,
            contractCreated: true,
            folio: contract.data.id,
          });
        } else {
          this.setState({
            creactedContract: contract.data.contracts[0],
            loading: false,
            contractCreated: true,
            folio: contract.data.contracts[0].id,
          });
        }
        return contract;
      } else {
        this.showError();
        return false;
      }
    } catch (error) {
      this.showError();
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to clear the localStorage and close the sesion
   * @date 15-12-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  onCloseSesion = async () => {
    let logo = await this.localStorageService.getLocalStorageItem("clientLogo");
    let promotion = await this.localStorageService.getLocalStorageItem(
      "promotion"
    );
    await this.localStorageService.clearLocalStorage();
    await this.localStorageService.setLocalStorageItem(
      "clientLogo",
      logo ? logo : ""
    );
    if (promotion) {
      await this.localStorageService.setLocalStorageItem(
        "promotion",
        promotion
      );
    }
  };

  async fetchClientImage() {
    let result = await this.clientService.getClientImage(this.token);
    return result?.data?.image;
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    this.user = this.localStorageService.getLocalStorageItem("user");

    //set the email of the user as default 
    this.setState({ email: this.user.userMetaData.userA3Cloud.email });

    let token = this.localStorageService.getLocalStorageItem("token");
    let userCapturedInformation = this.localStorageService.getLocalStorageItem(
      "userCapturedInformation"
    );
    let userBussinesInformation = this.localStorageService.getLocalStorageItem(
      "userBussinesInformation"
    );
    let chargeId = this.localStorageService.getLocalStorageItem("chargeId");
    let chargeURL = this.localStorageService.getLocalStorageItem("chargeURL");
    let promotion = this.localStorageService.getLocalStorageItem("promotion");

    if (promotion === true) {
      this.setState({ promotion: true });
    }
    moment.locale("es");

    if (token) {
      this.token = token.idToken;
    } else {
      window.location.hash = "";
    }
    let dateResumeStart = new Date();
    let dateFormatResume = moment(dateResumeStart).format("DD/MMMM/YYYY");

    await this.localStorageService.setLocalStorageItem("clientLogo", "");
    // let logo = await this.fetchClientImage();
    // await this.localStorageService.setLocalStorageItem(
    //   "clientLogo",
    //   logo ? logo : ""
    // );

    let data = {
      selectedPersonType: true,
      reload: true,
      preload: true,
      loading: false,
      dateResume: dateFormatResume
    };

    if (userCapturedInformation) {
      data.firstName = userCapturedInformation.firstName;
      data.firstLastName = userCapturedInformation.firstLastName;
      data.secondLastName = userCapturedInformation.secondLastName;
      data.phoneNumber = userCapturedInformation.phoneNumber;
      data.cellphoneNumber = userCapturedInformation.cellphoneNumber;
      data.rfc = userCapturedInformation.rfc;
      data.colony = userCapturedInformation.colony;
      data.state = userCapturedInformation.state;
      data.street = userCapturedInformation.street;
      data.township = userCapturedInformation.township;
      data.zipCode = userCapturedInformation.zipCode;
      data.personlDataFill = true;
    }

    if (userBussinesInformation) {
      data.colonyTaxData = userBussinesInformation.colonyTaxData;
      data.stateTaxData = userBussinesInformation.stateTaxData;
      data.streetTaxData = userBussinesInformation.streetTaxData;
      data.townshipTaxData = userBussinesInformation.townshipTaxData;
      data.zipCodeTaxData = userBussinesInformation.zipCodeTaxData;
      data.clientName = userBussinesInformation.clientName;
      data.rfcTaxData = userBussinesInformation.rfcTaxData;
      data.businessDataFill = true;
    }

    // Animation view
    AOS.init({
      duration: 1000,
    });

    this.setState(data);

    if (chargeId && chargeURL) {
      if (userBussinesInformation) {
        this.setState({
          loading: true,
          selectedStep: 5,
          selectedPersonType: true,
          selectedPersonTypeId: 2,
          termnsAndConditions: true,
          planChecked: true,
        });
      } else if (userCapturedInformation) {
        this.setState({
          loading: true,
          selectedStep: 4,
          selectedPersonType: true,
          selectedPersonTypeId: 1,
          termnsAndConditions: true,
          planChecked: true,
        });
      }
      chargeURL.transactionId = chargeId;
      await this.createContract(chargeURL, this.token);
      this.localStorageService.deleteElementLocalStorage("chargeId");
      this.localStorageService.deleteElementLocalStorage("chargeURL");
    }
    return true;
  };



  /**
   * @description reloads the page at the end of the registration process.
   * @status no delete
   * @memberof RegistrationAction
   */
  onRegisterEnd = () => {
    window.location.reload();
  };


  /**
   * @description resend code to user.
   * @status no delete
   * @param {*} event
   * @memberof RegistrationAction
   */
  onReSendMessage = async (event) => {
    event.preventDefault();
    let email = this.state.email;

    let message = this.messageService.sendEmailMessage(email, this.token);
    return message;
  };

  //Button Validate input

  /**
   * @status no delete
   * @memberof RegistrationAction
   */
  handleClick = () => {
    this.input.current.focus();
  };


  /**
   * @status no delete
   * @memberof RegistrationAction
   */
  handleFocus = () => {
    this.setState({ focused: true });
  };


  /**
   * @status no delete
   * @memberof RegistrationAction
   */
  handleBlur = () => {
    this.setState({
      focused: false,
    });
  };


  /**
   * @status no delete
   * @param {*} e
   * @memberof RegistrationAction
   */
  handleChange = (e) => {
    const validationCode = e.target.value;
    const CODE_LENGTH = new Array(6).fill(0);

    this.setState((state) => {
      if (state.validationCode.length >= CODE_LENGTH.length) return null;
      return {
        validationCode: (state.validationCode + validationCode).slice(
          0,
          CODE_LENGTH.length
        ),
      };
    });
  };


  /**
   * @status no delete
   * @param {*} e
   * @memberof RegistrationAction
   */
  handleKeyUp = (e) => {
    if (e.key === "Backspace") {
      this.setState((state) => {
        return {
          validationCode: state.validationCode.slice(
            0,
            state.validationCode.length - 1
          ),
        };
      });
    }
  };

  render = () => {
    if (this.state.loading) {
      return <SimpleLoading />;
    } else {
      return (
        <UserRegisterView
          {...this.state}
          back={this.back}
          changeTranslates={this.changeTranslates}
          fisica={this.fisica}
          getTranslates={this.getTranslates}
          goToApp={() => this.onRegisterEnd(this.state.contract)}
          handleBlur={this.handleBlur}
          handleChange={this.handleChange}
          handleClick={this.handleClick}
          handleFocus={this.handleFocus}
          handleKeyUp={this.handleKeyUp}
          input={this.input}
          notification={this.notification}
          onAcceptMessageTransfer={this.onAcceptMessageTransfer}
          onAcceptPlan={this.onAcceptPlan}
          onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
          onBackStep={this.onBackStep}
          onChangeValue={this.onChangeValue}
          onCloseOpenModal={this.onCloseOpenModal}
          onCloseSesion={this.onCloseSesion}
          onHandleHideError={this.onHandleHideError}
          onReSendMessage={this.onReSendMessage}
          onSelectPersonType={this.onSelectPersonType}
          onSubmit={this.onSubmit}
          openModalTermsCond={this.openModalTermsCond}
          principal={this.personType}
          stepMetadata={this.physicalStepMetadata}
          stepperIsLastStep={this.stepperIsLastStep}
          steps={this.state.physicalSteps}
          toggleErrorRequesting={this.toggleErrorRequesting}
          toggleWarningRequesting={this.toggleWarningRequesting}
          topScroll={true}
          validateInput={ValidateInputPure}
          validator={this.validator}
          warning={this.state.warning}
        />
      );
    }
  };
}


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function RegistrationActionContainer(props) {
  const { t } = useTranslation();
  return <RegistrationAction {...props} t={t} />;
}

export default scriptLoader([
  "https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js",
  "https://js.openpay.mx/openpay.v1.min.js",
  "https://js.openpay.mx/openpay-data.v1.min.js",
])(RegistrationActionContainer);
